"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildDepGraph = buildDepGraph;
const path = require("path");
const fs = require("fs");
const lockFileParser = require("snyk-nodejs-lockfile-parser");
const snyk_nodejs_lockfile_parser_1 = require("snyk-nodejs-lockfile-parser");
async function buildDepGraph(root, manifestFilePath, lockfilePath, lockfileVersion, options) {
    const manifestFileFullPath = path.resolve(root, manifestFilePath);
    const lockFileFullPath = path.resolve(root, lockfilePath);
    if (!fs.existsSync(manifestFileFullPath)) {
        throw new snyk_nodejs_lockfile_parser_1.InvalidUserInputError('Target file package.json not found at ' +
            `location: ${manifestFileFullPath}`);
    }
    if (!fs.existsSync(lockFileFullPath)) {
        throw new snyk_nodejs_lockfile_parser_1.InvalidUserInputError('Lockfile not found at location: ' + lockFileFullPath);
    }
    const manifestFileContents = fs.readFileSync(manifestFileFullPath, 'utf-8');
    const lockFileContents = fs.readFileSync(lockFileFullPath, 'utf-8');
    const workspaceRootPath = path.parse(lockFileFullPath).dir;
    const workspaceFileFullPath = path.resolve(workspaceRootPath, 'pnpm-workspace.yaml');
    switch (lockfileVersion) {
        case snyk_nodejs_lockfile_parser_1.NodeLockfileVersion.PnpmLockV5:
        case snyk_nodejs_lockfile_parser_1.NodeLockfileVersion.PnpmLockV6:
        case snyk_nodejs_lockfile_parser_1.NodeLockfileVersion.PnpmLockV9:
            if (fs.existsSync(workspaceFileFullPath)) {
                throw new snyk_nodejs_lockfile_parser_1.InvalidUserInputError('Both `pnpm-lock.yaml` and `pnpm-workspace.yaml` were found in ' +
                    workspaceRootPath +
                    '.\n' +
                    'Please run your command again specifying `--all-projects` flag.');
            }
            return await lockFileParser.parsePnpmProject(manifestFileContents, lockFileContents, {
                includeDevDeps: options.includeDevDeps,
                includeOptionalDeps: options.includeOptionalDeps || true,
                includePeerDeps: true,
                pruneWithinTopLevelDeps: true,
                strictOutOfSync: options.strictOutOfSync,
            }, lockfileVersion);
        case snyk_nodejs_lockfile_parser_1.NodeLockfileVersion.YarnLockV1:
            return await lockFileParser.parseYarnLockV1Project(manifestFileContents, lockFileContents, {
                includeDevDeps: options.includeDevDeps,
                includeOptionalDeps: options.includeOptionalDeps,
                includePeerDeps: options.includePeerDeps || false,
                pruneLevel: 'withinTopLevelDeps',
                strictOutOfSync: options.strictOutOfSync,
            });
        case snyk_nodejs_lockfile_parser_1.NodeLockfileVersion.YarnLockV2:
            return await lockFileParser.parseYarnLockV2Project(manifestFileContents, lockFileContents, {
                includeDevDeps: options.includeDevDeps,
                includeOptionalDeps: options.includeOptionalDeps,
                pruneWithinTopLevelDeps: true,
                strictOutOfSync: options.strictOutOfSync,
            });
        case snyk_nodejs_lockfile_parser_1.NodeLockfileVersion.NpmLockV2:
        case snyk_nodejs_lockfile_parser_1.NodeLockfileVersion.NpmLockV3:
            return await lockFileParser.parseNpmLockV2Project(manifestFileContents, lockFileContents, options);
        default:
            throw new Error('Failed to build dep graph from current project');
    }
}
//# sourceMappingURL=build-dep-graph.js.map